import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { EnumCodigosTwTcAcciones, EnumIdsTcEstadoSolicitud, EnumIdsTwTcTipoClonacion } from '../types/enum';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { HttpParams } from '@angular/common/http';
import { ProductosService } from '../productos/productos.service';
import { SolicitudProductosViewModel, TProductoSolicitudViewModel, TwEmbalajesViewModel } from '../productos/productos.types';
import { ConfirmationService } from 'primeng/api';
import { TRechazoParcialSolicitudViewModel } from './inspecciones.types';
import { InspeccionesService } from './inspecciones.service';

@Component({
    selector: 'app-rechazoparcial',
    templateUrl: './rechazoparcial.component.html',
})
export class RechazoParcialComponent extends ComponentBase implements OnInit {
    editMode: boolean;

    solicitudProductos: SolicitudProductosViewModel;
    rechazoParcialCollection: TRechazoParcialSolicitudViewModel[] = [];
    colsProds: any[];
    colsEmbalajes: any[];
    numeroBultosTotales = 0;
    IdEstadoSolicitud: number;
    tituloTipoSolicitud: string;
    EstadoSolicitudDescripcion: string;
    EsPredua: boolean;
    CodigoSolicitud: string;
    CodigoTipoSolicitud: string;
    IdTipoSolicitud: number;
    IdEstadoChedPp: number | null;
    IdEstadoChedPpDescripcion: string;
    IdResultadoEnvioMuestrasLaboratorio: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorio: string;

    public habilitarGuardar = true;
    visibilitySpinner = false;
    esClonada = false;
    idSolicitud: number;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public datepipe: DatePipe,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudService: SolicitudService,
        private productosService: ProductosService,
        private inspeccionesService: InspeccionesService,
        protected notificationService: NotificationService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager, //private inspeccionesService: InspeccionesService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit() {
        this.createForm();

        this.idSolicitud = this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitud);

        if (this.idSolicitud) {
            this.loadSolicitudProductosById();
        }

        this.createColsForTables();
    }

    private createColsForTables(): void {
        // Cambios Productos
        this.colsProds = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'CodigoTaric', header: 'Cód. Taric' },
            { field: 'IdPaisDescripcion', header: 'País Origen' },
            { field: 'IdBotanicaDescripcion', header: 'Nom Científico' },
            { field: 'CodigoEppo', header: 'Cód. EPPO' },
            { field: 'NombreComun', header: 'Nombre Común' },
            { field: 'Grupo', header: 'Grupo' },
            { field: 'IdFormaDescripcion', header: 'Forma' },
            { field: 'Peso', header: 'Peso (Kg)' },
            { field: 'Unidades', header: 'Unidades (Ud)' },
            { field: 'Volumen', header: 'Volumen (m³)' },
            { field: 'NumeroBulto', header: 'Bultos' },
            //{ field: 'EsOrganico', header: 'Orgánico' }, //RDLF: tarea producto Orgánico (93379) se comenta de manera temporal
        ];

        //Cambios Embalajes
        this.colsEmbalajes = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            {
                field: 'IdTaricEmbalajeDescripcion',
                header: 'Material de Embalaje',
            },
            { field: 'IdEppoEmbalajeDescripcion', header: 'Cód. EPPO' },
            { field: 'Recuento', header: 'Recuento' },
            { field: 'IdUnidadEmbalajeDescripcion', header: 'Unidad' },
            { field: 'IdPaisEmbalajeDescripcion', header: 'País Origen' },
        ];
    }

    /**
     * Este método se invoca al cargar el componente y una vez se ha obtenido información sobre si el usuario ha grabado o no la solicitud.
     * Se obtiene la siguiente información:
     * - Lista de productos de la solicitud
     * - S comprueba si la solicitud es clonada.
     * - Se rellena el título indicando si la solicitud es:
     *   - re-importación
     *   - previa
     * - Se obtienen los permisos en función de si el usuario es grabador y/o inspector
     * - Se obtiene el número de productos y embajales.
     */
    private loadSolicitudProductosById(): void {
        this.productosService.getSolicitudProductos(this.idSolicitud).subscribe(result => {
            this.solicitudProductos = result;
            this.IdTipoSolicitud = this.solicitudProductos.IdTipoSolicitud;
            this.IdEstadoSolicitud = this.solicitudProductos.IdEstadoSolicitud;
            this.EstadoSolicitudDescripcion = this.solicitudProductos.IdEstadoSolicitudDescripcion;
            this.tituloTipoSolicitud = this.solicitudProductos.IdTipoSolicitudDescripcion;
            this.esClonada =
                this.solicitudProductos.TwSolicitudJerarquia != null &&
                this.solicitudProductos.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                    ? true
                    : false;
            // SI ES RE-IMPORTACION
            if (this.solicitudProductos.EsReImportacion) {
                this.tituloTipoSolicitud += ' - Re-Importación';
            }
            // SI ES PREVIA
            if (this.solicitudProductos.EsPrevia) {
                if (
                    this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                    this.solicitudProductos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                ) {
                    this.tituloTipoSolicitud += ' - Previa';
                }
            }

            this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.VER_RECHAZO_PARCIAL, this.IdEstadoSolicitud).Editable;

            this.calculoNumeroBultos();

            //cargo la coleccion de Rechazos Parciales (productos y embalajes)
            this.solicitudProductos.TProductoSolicitudCollection.forEach(x => {
                const rechazoParcial = new TRechazoParcialSolicitudViewModel();
                rechazoParcial.IdProducto = x.Id;
                rechazoParcial.Aceptado = null;
                this.rechazoParcialCollection.push(rechazoParcial);
            });
            this.solicitudProductos.TwEmbalajesCollection.forEach(y => {
                const rechazoParcial = new TRechazoParcialSolicitudViewModel();
                rechazoParcial.IdEmbalaje = y.Id;
                rechazoParcial.Aceptado = null;
                this.rechazoParcialCollection.push(rechazoParcial);
            });
        });
    }

    /**
     * Este método calcula el número total del bultos a partir del recuento de los embalajes.
     */
    private calculoNumeroBultos() {
        this.numeroBultosTotales = 0;
        this.solicitudProductos?.TwEmbalajesCollection.forEach(y => {
            this.numeroBultosTotales += y?.Recuento;
        });
    }

    createForm() {
        this.form = this.fb.group({});
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    marcarProductoAceptado(producto: TProductoSolicitudViewModel, marca: boolean) {
        producto.Aceptado = marca;
        //modificar el valor 'Aceptado' en la coleccion
        const rechazoParcial = this.rechazoParcialCollection.filter(x => x.IdProducto == producto.Id).shift();
        rechazoParcial!.Aceptado = marca;
    }

    marcarEmbalajeAceptado(embalaje: TwEmbalajesViewModel, marca: boolean) {
        embalaje.Aceptado = marca;
        //modificar el valor 'Aceptado' en la coleccion
        const rechazoParcial = this.rechazoParcialCollection.filter(x => x.IdEmbalaje == embalaje.Id).shift();
        rechazoParcial!.Aceptado = marca;
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/inspecciones', this.navMenuService.currentSolicitudImportacion.Id]);
    }

    onGuardarRechazoParcial(): void {
        this.confirmationService.confirm({
            message: '¿Está seguro?. ',
            accept: () => {
                this.onSubmit();
            },
        });
    }

    onSubmit() {
        this.submitted = true;

        if (this.rechazoParcialCollection.some(t => t.Aceptado == null)) {
            this.addErrorMessage('Tiene que aceptar o rechazar todos los productos y embalajes');
            return;
        }
        if (
            !(
                this.rechazoParcialCollection.some(t => t.IdProducto != null && t.Aceptado) &&
                this.rechazoParcialCollection.some(y => y.IdProducto != null && !y.Aceptado)
            )
        ) {
            this.addErrorMessage('Tiene que marcar al menos un producto como "Aceptado" y otro como "Rechazado"');
            return;
        }

        this.visibilitySpinner = true;

        //llamada al metodo de creación de las solicitudes 'hijas'
        this.inspeccionesService.rechazoParcial(this.rechazoParcialCollection).subscribe({
            next: () => {
                this.addSuccessMessage('Rechazo parcial realizado correctamente');
                this.visibilitySpinner = false;
                this.onBack();
                //ir a datos basicos?
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }
}
